import { StyledCheckbox } from '../PointsOfInterest/SummaryCard/styles';
import { ActionHeaderContainer } from './styles';
import { FormControlLabel, Typography } from '@mui/material';
import { BulkReviewAction } from './BulkReviewAction';
import { useAtom, useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';

export const ActionHeader = ({
  variant = 'default',
  poiType,
  location = 'review-panel',
}: {
  variant?: 'default' | 'compact';
  poiType?: string;
  location?: string;
}) => {
  const [isAllReviewPointsOfInterestSelected, setIsAllReviewPointsOfInterestSelected] = useAtom(
    state.isAllReviewPointsOfInterestSelected
  );
  const setSelectedReviewPointsOfInterest = useSetAtom(state.selectedReviewPointsOfInterest);
  const handleSelectAllChange = (
    _event: React.SyntheticEvent<Element, Event>,
    checked: boolean
  ) => {
    setIsAllReviewPointsOfInterestSelected(checked);
    setSelectedReviewPointsOfInterest([]);
  };
  return (
    <ActionHeaderContainer variant={variant}>
      {variant === 'default' && (
        <FormControlLabel
          sx={{
            gap: '1.2rem',
            margin: 0,
          }}
          checked={isAllReviewPointsOfInterestSelected}
          control={<StyledCheckbox disableRipple />}
          label={
            <Typography variant="caption" fontWeight={600} color="primary.500">
              Select all
            </Typography>
          }
          onChange={handleSelectAllChange}
        />
      )}
      <BulkReviewAction
        variant={variant}
        poiType={poiType}
        className={`${location}-bulk-review-action`}
      />
    </ActionHeaderContainer>
  );
};
